module.exports = __webpack_public_path__ + "static/media/video-2.be76beec.jpg";